<template>
  <div>
    <div
      klickbox-edit-item="general"
      :klickbox-edit-label="$t('edit.canvas.general_styles')">
      <progress-bar v-if="boxConfig.progressbar.kind !== 'counter'"></progress-bar>
      <div class="kbx-content">
        <counter v-if="boxConfig.progressbar.kind === 'counter'"></counter>
        <title-preview></title-preview>
        <description></description>
        <options></options>
        <button-next></button-next>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProgressBar from '../../progressbar/Main';
import TitlePreview from './../Title';
import Description from './../Description';
import Options from './Options';
import ButtonNext from './../ButtonNext';
import Counter from './../Counter';

export default {
  components: {
    ProgressBar,
    TitlePreview,
    Description,
    Options,
    ButtonNext,
    Counter,
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?41e144ca
 **/